<template>
  <v-layout class="grey lighten-4" column>
    <div class="noto bold pa-3 d-md-flex align-center" width="100%">
      <div class="title primary--text">{{ section }}</div>
      <v-spacer></v-spacer>
      <div class="d-flex justify-end align-center mr-3">
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Busca usuarios por email"
          solo
          hide-details
          rounded
          flat
          dense />
      </div>
      <v-dialog @keydown.esc="createDialog=false" v-model="createDialog" persistent max-width="600px">
        <template v-slot:activator="{ on }">
          <v-btn
            v-if="userPermissions['create-user']"
            data-cy="add-userProvider"
            v-on="on"
            fab
            x-small
            depressed
            color="primary"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </template>
        <v-card>
          <v-card-title>
            <span class="headline">{{!form.data._id ? 'Crear usuario' : 'Editar usuario'}}</span>
          </v-card-title>
          <v-card-text>
            <v-form ref="userForm" v-model="form.valid">
              <v-container grid-list-xl>
                <v-layout wrap>
                  <v-flex xs6 md6>
                    <v-text-field
                      data-cy="email-restaurant"
                      v-model="form.data.email"
                      label="Email"
                      :rules="form.rules.email"
                      :disabled="isEditing"
                      required>
                    </v-text-field>
                  </v-flex>
                  <v-flex xs6 md6>
                    <v-select
                      data-cy="role-restaurant"
                      label="Rol"
                      :rules="form.rules.role"
                      v-model="form.data.role"
                      :items="roles"
                      item-text="text"
                      item-value="value"
                      required>
                      <template v-slot:item="{ item }">
                        <v-tooltip
                          right
                          max-width="200">
                          <template v-slot:activator="{ on }">
                            <v-list-item v-on="on">
                              {{ item.text }}
                            </v-list-item>
                          </template>
                          <span>
                            {{ item.hint }}
                          </span>
                        </v-tooltip>
                      </template>
                    </v-select>
                  </v-flex>
                  <v-flex xs6 md6 class="px-4">
                    <v-select
                      label="Puesto"
                      v-model="form.data.employment"
                      :rules="form.rules.employment"
                      :items="employments"
                      item-text="text"
                      item-value="value"
                      required>
                      <template v-slot:item="{ item }">
                        <v-tooltip
                          right
                          max-width="200">
                          <template v-slot:activator="{ on }">
                            <v-list-item v-on="on">
                              {{ item.text }}
                            </v-list-item>
                          </template>
                          <!-- <span>
                            {{ item.hint }}
                          </span> -->
                        </v-tooltip>
                      </template>
                    </v-select>
                  </v-flex>
                  <v-flex md12>
                    <v-expansion-panels accordion>
                      <v-expansion-panel>
                        <v-expansion-panel-header expand-icon="mdi-menu-down" data-cy="permission">
                          Ver permisos del usuario
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <div
                            v-for="(permission, index) in availablePermissions"
                            :key="`permission-${index}`">
                            <div>
                              <v-checkbox
                                data.cy="purchase-sideMenu"
                                v-model="permissionsForm[permission.module].visible"
                                :label="permission.label"
                                color="primary"
                                hide-details
                                @change="checkModule({ module: permission.module }, $event)"
                              />
                            </div>
                            <div v-if="permission.components.length">
                              <v-divider class="mt-3"/>
                              <div class="pl-4 pt-3">
                                Componentes:
                              </div>
                              <div
                                v-for="(component, index) in permission.components"
                                :key="`component-${index}`"
                                class="pl-4">
                                <div>
                                  <v-checkbox
                                    v-model="permissionsForm[permission.module].components[component.component].visible"
                                    :label="component.label"
                                    color="primary"
                                    hide-details
                                    :disabled="!permissionsForm[permission.module].visible"
                                    @change="checkComponent({ module: permission.module, component: component.component }, $event)"
                                  />
                                </div>
                                <div v-if="component.actions.length">
                                  <div class="pl-4 pt-4">
                                    Acciones:
                                  </div>
                                  <div
                                    v-for="(action, index) in component.actions"
                                    :key="`action-${index}`"
                                    class="pl-4">
                                    <v-checkbox
                                      v-model="permissionsForm[permission.module].components[component.component].actions[action.action]"
                                      :label="action.label"
                                      color="primary"
                                      :disabled="!permissionsForm[permission.module].components[component.component].visible"
                                      hide-details
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" small @click="onCloseCreateDialog">Cerrar</v-btn>
            <v-btn color="primary" small @click="submit" :disabled="!form.valid" data-cy="submit">Guardar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>

    <v-flex xs12>
      <v-data-table
        loading-text="Cargando users"
        :server-items-length="table.total"
        :loading="table.loading"
        :headers="table.headers"
        :items="table.data"
        :options="table.options"
        sort-by="email"
        @update:options="updateTable"
        class="elevation-1 fixed-header">
        <template v-slot:item.role="{ item }">
          <div>
            {{ getRole(item.role) }}
          </div>
          <div class="caption grey--text">
            <span v-if="item.employment">
              {{ getEmployment(item.employment) }}
            </span>
            <span v-else>
              -
            </span>
          </div>
        </template>
        <template v-slot:item.action="{ item }">
          <div class="d-flex justify-end align-center">
            <v-tooltip v-if="item.invitation && userPermissions['resend-provider-invitation']" left>
              <template
                v-slot:activator="{ on }">
                <v-btn
                  fab
                  x-small
                  depressed
                  color="info"
                  class="mr-2"
                  v-on="on"
                  @click="onOpenInviteUserDialog(item)">
                  <v-icon>mdi-email</v-icon>
                </v-btn>
              </template>
              <span>Reenviar invitación</span>
            </v-tooltip>
            <v-tooltip v-if="userPermissions['update-user']" left>
              <template
                v-slot:activator="{ on }">
                <v-btn
                  fab
                  x-small
                  depressed
                  color="primary"
                  class="mr-2"
                  v-on="on"
                  @click="onOpenUpdateUserDialog(item)">
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>Editar usuario</span>
            </v-tooltip>
            <v-tooltip v-if="userPermissions['delete-user']" left>
              <template
                v-slot:activator="{ on }">
                <v-btn
                  fab
                  x-small
                  depressed
                  color="error"
                  v-on="on"
                  @click="onOpenRemoveUserDialog(item)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </template>
              <span>Eliminar usuario</span>
            </v-tooltip>
          </div>
        </template>
      </v-data-table>
    </v-flex>

    <v-dialog @keydown.esc="removeDialog=false" v-model="removeDialog" persistent max-width="max-content">
      <v-card>
        <v-card-title>
          <span class="headline">¿Deseas eliminar a: {{ this.form.data.email }}?</span>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" small @click="onCloseRemoveDialog">No</v-btn>
          <v-btn color="primary" small @click="remove">Si</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog @keydown.esc="inviteDialog=false" v-model="inviteDialog" persistent max-width="300px">
      <v-card>
        <v-card-title>
          <span class="headline">¿Deseas mandar una invitación a: {{ this.form.data.email }}?</span>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" small @click="onCloseInviteDialog">No</v-btn>
          <v-btn color="primary" small @click="invite">Si</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-overlay :value="overlay" z-index="999999999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-layout>
</template>

<script>
import { cloneDeep, debounce } from 'lodash'

export default {
  name: 'Colaboradores',
  data () {
    return {
      createDialog: false,
      removeDialog: false,
      inviteDialog: false,
      roles: [
        {
          text: 'Administrador general',
          value: 'provider',
          hint: 'El Administrador general tiene acceso a todas las opciones de la plataforma.'
        },
        {
          text: 'Asistente de compras',
          value: 'provider-buyer',
          hint: 'Asistente de compras tendrá acceso al catálogo de productos, pedido general, ordenes de compra y reclamaciones.'
        }
      ],
      allRoles: [
        {
          text: 'Administrador general',
          value: 'provider',
          hint: 'El Administrador general tiene acceso a todas las opciones de la plataforma.'
        },
        // {
        //   text: 'Administrador general',
        //   value: 'provider-manager',
        //   hint: 'El Administrador general tiene acceso a todas las opciones de la plataforma.'
        // },
        {
          text: 'Asistente de compras',
          value: 'provider-buyer',
          hint: 'Asistente de compras tendrá acceso al catálogo de productos, pedido general, ordenes de compra y reclamaciones.'
        }
      ],
      employments: [
        {
          text: 'Ventas',
          value: 'sales'
        },
        {
          text: 'Contabilidad',
          value: 'accounting'
        },
        {
          text: 'Facturación',
          value: 'billing'
        }
      ],
      overlay: false,
      section: this.$i18n.t('menu.settings.users'),
      table: {
        title: 'Loading users',
        loading: true,
        headers: [
          { text: 'Email', value: 'email' },
          { text: 'Rol', value: 'role', sortable: false },
          { text: 'Actions', value: 'action', sortable: false }
        ],
        data: [],
        total: 0,
        options: {
          itemsPerPage: 15,
          page: 1
        }
      },
      form: {
        valid: false,
        data: {
          uuid: null,
          email: null,
          role: null,
          invitation: null,
          employment: null
        },
        rules: {
          role: [v => !!v || this.$t('validations.role')],
          email: [
            v => !!v || this.$t('validations.email.required'),
            v => /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(v) || this.$t('validations.email.valid')
          ],
          concept: [v => !!v || 'Concept is required']
        }
      },
      permissionsForm: {
        'purchase-orders': {
          visible: true,
          components: {
            'purchase-orders-list': {
              visible: true,
              actions: {
                'change-purchase-order-to-read': true,
                'change-purchase-order-status-to-confirmed': true,
                'change-purchase-order-add-product': true,
                'change-purchase-order-add-service': true,
                'create-purchase-order-invoice': true,
                'upload-purchase-order-invoice': true,
                'change-purchase-order-status-to-received': true,
                'change-purchase-order-status-to-cancelled': true,
                'send-purchase-order-via-email': true,
                'copy-purchase-order-link': true,
                'print-purchase-order': true,
                'change-purchase-order-update-product-price': true,
                'change-purchase-order-update-product-quantity-confirmed': true,
                'change-purchase-order-cancel-invoice': true,
                'upload-credit-note': true,
                'create-credit-note': true
              }
            }
          }
        },
        'my-deposits': {
          visible: true,
          components: {
            'deposits-list': {
              visible: true,
              actions: {
                'receive-deposits-notifications': true,
                'export-deposits-report': true
              }
            }
          }
        },
        'my-taxes': {
          visible: true,
          components: {
            'taxes-list': {
              visible: true,
              actions: {
                'create-tax': true,
                'edit-tax': true,
                'delete-tax': true
              }
            }
          }
        },
        'products-catalog': {
          visible: true,
          components: {
            'products-catalog-list': {
              visible: true,
              actions: {
                'edit-taxes': true,
                'create-product': true,
                'edit-product': true,
                'delete-product': true,
                'upload-invoice': true
              }
            }
          }
        },
        'settings': {
          visible: true,
          components: {
            'users': {
              visible: true,
              actions: {
                'create-user': true,
                'update-user': true,
                'delete-user': true,
                'resend-provider-invitation': true
              }
            },
            'tax-information': {
              visible: true,
              actions: {
                'change-provider-tax-information': true
              }
            },
            'bank-information': {
              visible: true,
              actions: {
                'change-provider-bank-information': true
              }
            },
            'purchase-orders-notification-provider': {
              visible: true,
              actions: {
                'purchase-orders-notification-provider': true
              }
            }
          }
        },
        'notifications': {
          visible: true,
          components: {
            orders: {
              visible: true,
              actions: {
                'sent-or-cancel-pucharse-orders': true
              }
            }
          }
        }
      },
      availablePermissions: [
        {
          module: 'purchase-orders',
          label: 'Secciones de órdenes de compra en menú lateral',
          components: [
            {
              component: 'purchase-orders-list',
              label: 'Órdenes de compra',
              actions: [
                {
                  action: 'change-purchase-order-to-read',
                  label: 'Mandar a confirmar orden'
                },
                {
                  action: 'change-purchase-order-status-to-confirmed',
                  label: 'Confirmar órdenes de compra'
                },
                {
                  action: 'change-purchase-order-add-product',
                  label: 'Agregar producto'
                },
                {
                  action: 'change-purchase-order-add-service',
                  label: 'Agregar servicio'
                },
                {
                  action: 'create-purchase-order-invoice',
                  label: 'Generar factura'
                },
                {
                  action: 'upload-purchase-order-invoice',
                  label: 'Subir factura'
                },
                {
                  action: 'change-purchase-order-status-to-received',
                  label: 'Recibir mercancía'
                },
                {
                  action: 'change-purchase-order-status-to-cancelled',
                  label: 'Cancelar orden de compra'
                },
                {
                  action: 'send-purchase-order-via-email',
                  label: 'Enviar orden de compra por mail'
                },
                {
                  action: 'copy-purchase-order-link',
                  label: 'Copiar link de orden de compra'
                },
                {
                  action: 'print-purchase-order',
                  label: 'Imprimir orden de compra'
                },
                {
                  action: 'change-purchase-order-update-product-price',
                  label: 'Cambiar precio de producto'
                },
                {
                  action: 'change-purchase-order-update-product-quantity-confirmed',
                  label: 'Cambiar cantidad confirmada de producto'
                },
                {
                  action: 'change-purchase-order-cancel-invoice',
                  label: 'Cancelar factura'
                },
                {
                  action: 'upload-credit-note',
                  label: 'Subir nota de crédito'
                },
                {
                  action: 'create-credit-note',
                  label: 'Generar nota de crédito'
                }
              ]
            }
          ]
        },
        {
          module: 'my-deposits',
          label: 'Sección de "Mis depósitos"',
          components: [
            {
              component: 'deposits-list',
              label: 'Lista de depósitos',
              actions: [
                {
                  action: 'receive-deposits-notifications',
                  label: 'Recibir notificaciones de depósitos'
                },
                {
                  action: 'export-deposits-report',
                  label: 'Exportar depósitos a CSV'
                }
              ]
            }
          ]
        },
        {
          module: 'my-taxes',
          label: 'Sección de "Mis impuestos"',
          components: [
            {
              component: 'taxes-list',
              label: 'Lista de impuestos',
              actions: [
                {
                  action: 'create-tax',
                  label: 'Crear impuesto'
                },
                {
                  action: 'edit-tax',
                  label: 'Editar impuesto'
                },
                {
                  action: 'delete-tax',
                  label: 'Borrar impuesto'
                }
              ]
            }
          ]
        },
        {
          module: 'products-catalog',
          label: 'Sección "Catálogo de productos"',
          components: [
            {
              component: 'products-catalog-list',
              label: 'Lista de catálogo',
              actions: [
                {
                  action: 'edit-taxes',
                  label: 'Editar impuestos'
                },
                {
                  action: 'create-product',
                  label: 'Crear producto'
                },
                {
                  action: 'edit-product',
                  label: 'Editar producto'
                },
                {
                  action: 'delete-product',
                  label: 'Borrar producto'
                },
                {
                  action: 'upload-invoice',
                  label: 'Subir factura'
                }
              ]
            }
          ]
        },
        {
          module: 'settings',
          label: 'Ajustes de proveedor',
          components: [
            {
              component: 'users',
              label: 'Usuarios',
              actions: [
                {
                  action: 'create-user',
                  label: 'Crear usuario'
                },
                {
                  action: 'update-user',
                  label: 'Actualizar usuario'
                },
                {
                  action: 'delete-user',
                  label: 'Borrar usuario'
                },
                {
                  action: 'resend-provider-invitation',
                  label: 'Reenviar invitación al usuario'
                }
              ]
            },
            {
              component: 'tax-information',
              label: 'Información fiscal',
              actions: [
                {
                  action: 'change-provider-tax-information',
                  label: 'Cambiar información fiscal'
                }
              ]
            },
            {
              component: 'bank-information',
              label: 'Información bancaria',
              actions: [
                {
                  action: 'change-provider-bank-information',
                  label: 'Cambiar información bancaria'
                }
              ]
            },
            {
              component: 'purchase-orders-notification-provider',
              label: 'Notificaciones de órdenes de compra',
              actions: [
                {
                  action: 'purchase-orders-notification-provider',
                  label: 'Notificar cuando soliciten o cancelen una orden de compra'
                }
              ]
            }
          ]
        },
        {
          module: 'notifications',
          label: 'Notificaciones',
          components: [
            {
              component: 'orders',
              label: 'Ordenes de compra',
              actions: [
                {
                  action: 'sent-or-cancel-pucharse-orders',
                  label: 'Notificar cuando soliciten o cancelen una orden de compra'
                }
              ]
            }
          ]
        }
      ],
      search: ''
    }
  },
  watch: {
    'search': debounce(async function (val) {
      if (val.length >= 3) {
        try {
          const params = {
            email: `/${val}/gi`,
            limit: this.table.options.itemsPerPage,
            skip: (this.table.options.itemsPerPage * (this.table.page - 1))
          }
          await this.load(params)
        } catch (error) {
          this.$toasted.show(error.message, { duration: 3000 })
        }
      } else {
        this.load()
      }
    }, 300)
  },
  computed: {
    provider () { return this.$store.state.currentProvider.data },
    userPermissions () {
      return this.$store.state.login.permissions['settings'].components['users'].actions
    },
    isEditing () {
      return !!this.form.data._id
    }
  },
  methods: {
    updateTable: async function (data) {
      const { sortBy, sortDesc } = data
      await this.load({
        limit: data.itemsPerPage,
        skip: (data.itemsPerPage * (data.page - 1)),
        sort: `${sortDesc[0] ? '-' : ''}${sortBy[0]}`
      })
    },
    async load (params = null) {
      params = params || {
        limit: this.table.options.itemsPerPage,
        skip: (this.table.options.itemsPerPage * (this.table.page - 1))
      }
      try {
        const response = await this.$api.get(`/v1/providers/${this.provider._id}/users`, params)
        this.table.data = response.data
        this.table.total = response.total
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.table.loading = false
    },
    onCloseCreateDialog: function () {
      if (this.$refs && this.$refs.userForm) this.$refs.userForm.reset()
      this.form.data = {}
      this.createDialog = false
    },
    onOpenUpdateUserDialog: function (user) {
      const cloneUser = cloneDeep(user)
      const permissions = cloneUser.permissions
      delete cloneUser.permissions
      this.form.data = cloneUser
      this.permissionsForm = permissions
      this.createDialog = true
    },
    onOpenRemoveUserDialog: function (user) {
      this.form.data = cloneDeep(user)
      this.removeDialog = true
    },
    onOpenInviteUserDialog: function (user) {
      this.form.data = cloneDeep(user)
      this.inviteDialog = true
    },
    onCloseRemoveDialog: function () {
      this.onCloseCreateDialog()
      this.removeDialog = false
    },
    onCloseInviteDialog: function () {
      this.onCloseCreateDialog()
      this.inviteDialog = false
    },
    submit: async function () {
      if (this.$refs.userForm.validate()) {
        this.overlay = true
        const request = this.form.data.uuid == null
          ? this.create()
          : this.update()
        try {
          await request
          await this.load()
          this.onCloseCreateDialog()
        } catch (error) {
          this.$toasted.show(error.message, { duration: 3500, type: 'error', position: 'top-center', iconPack: 'mdi', icon: 'mdi-cancel' })
        }
        this.overlay = false
      }
    },
    create: async function () {
      const payload = this.form.data
      payload.permissions = this.permissionsForm
      await this.$api.post(`/v1/providers/${this.provider._id}/users`, payload)
      this.$toasted.show(`Se creó exitosamente el usuario: "${payload.email}"`, { duration: 3500, type: 'success', position: 'top-center', iconPack: 'mdi', icon: 'mdi-check-circle' })
    },
    update: async function () {
      const payload = this.form.data
      payload.permissions = this.permissionsForm
      await this.$api.put(`/v1/providers/${this.provider._id}/users/${this.form.data.uuid}`, payload)
      this.$toasted.show(`Se modificó exítosamente el usuario: "${payload.email}"`, { duration: 3500, type: 'success', position: 'top-center', iconPack: 'mdi', icon: 'mdi-check-circle' })
    },
    remove: async function () {
      this.overlay = true
      try {
        await this.$api.del(`/v1/providers/${this.provider._id}/users/${this.form.data.uuid}`)
        await this.load()
        this.onCloseRemoveDialog()
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    },
    invite: async function () {
      this.overlay = true
      try {
        await this.$api.post(`/v1/invitations/${this.form.data.invitation}/resend`)
        await this.load()
        this.onCloseInviteDialog()
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    },
    getRole (role) {
      const foundRole = this.allRoles.find(r => r.value === role)
      return foundRole.text
    },
    getEmployment (employment) {
      const foundEmployment = this.employments.find(r => r.value === employment)
      return foundEmployment.text
    },
    checkModule ({ module }, value) {
      Object.keys(this.permissionsForm[module].components).forEach((key) => {
        this.permissionsForm[module].components[key].visible = value
        this.checkComponent({ module, component: key }, value)
      })
    },
    checkComponent ({ module, component }, value) {
      Object.keys(this.permissionsForm[module].components[component].actions).forEach((key) => {
        this.permissionsForm[module].components[component].actions[key] = value
      })
    }
  }
}
</script>

<style lang="css" scoped>
</style>
